export default {
  dbh_studio_report_all: 'All',
  dbh_studio_report_general_gaming: 'Marketing',
  dbh_studio_report_esports: 'In-Game Analytic',
  dbh_studio_report_view: 'View',
  dbh_studio_no_data: 'No data yet',
  dbh_studio_no_access_view: 'This module is not yet available. Please stay tuned.',
  dbh_studio_no_permission_view: 'No permission for this module. Please contact the Organization Manager.',
  dbh_studio_in_game_no_permission_woa: "You don't have access to this module. To request access, please contact {contact} via WeCom.",
  dbh_studio_in_game_no_permission_global: "You don't have access to this module. To request access, please email {contact}.",
  dbh_studio_header_explore: 'Explore',
  dbh_studio_report_title: "Report Portfolio",
  dbh_studio_report_sub_title: "Exclusive in-house insights and curated market reports tailored to your game",
  dbh_studio_hotevent_hot_tooltip: "Hot Events: Events ranked in the Top 3 for three or more consecutive days",
  dbh_studio_hotevent_new_tooltip: "New Event: Events occurring for the first time within 30 Days",
  dbh_studio_hotevent_rese_tooltip: "Rising Event：Events with an increase of 80% or more in comments compared to the previous day",
  dbh_studio_report_opinion_highlight: "Opinions Highlights",
  dbh_studio_report_filter_sorting: "Sort By",
  dbh_studio_report_bechmark_tips: "Click to go to the DataBrain Benchmark page",
  dbh_studio_opinions_report_gpt_more: "More",
  dbh_studio_opinions_report_gpt_close: "Close",
  dbh_studio_funcom_down_metrics: 'Metrics',
  dbh_studio_funcom_down_official_accounts_channel: 'Official Accounts Channel',
  dbh_studio_funcom_down_clear_all: 'Clear All',
  dbh_studio_funcom_down_select_all: 'Select All',
  dbh_studio_funcom_edit_modal_placeholder: 'Please input',
  dbh_studio_funcom_edit_modal_comfirm: 'Confirm',
  dbh_studio_funcom_edit_modal_cancel: 'Cancel',
  dbh_studio_funcom_edit_modal_gpt_title: 'Edit GPT Summary',
  dbh_studio_funcom_edit_modal_success: 'Editing successful',
  dbh_studio_funcom_edit_modal_failed: 'Edit failed',
  dbh_studio_funcom_add_modal_success: 'Adding successful',
  dbh_studio_funcom_add_modal_failed: 'Add failed',
  dbh_studio_funcom_delete_modal_success: 'Deleting successful',
  dbh_studio_funcom_delete_modal_failed: 'Delete failed',
  dbh_studio_funcom_save_modal_highlights_success: 'Save successful',
  dbh_studio_funcom_save_modal_highlights_failed: 'Save failed',
  dbh_studio_funcom_send_email: 'Email sent successfully',
  dbh_studio_funcom_send_email_failed: 'Email sending failed',
  dbh_studio_highlights: 'Highlights',
  dbh_studio_edit_highlights: 'Edit Highlights',
  dbh_studio_add_highlights: 'Add an Highlight',
  dbh_studio_add_highlights_1: 'Add Highlights',
  dbh_studio_summary: 'Executive Summary',
  dbh_studio_action: 'Actions',
  dbh_studio_input_placeholder: 'Please enter',
  dbh_studio_select_icon: 'Select icon',
  dbh_studio_add_row: 'Add a row of data',
  dbh_studio_no_content: "No content available",
  dbh_studio_no_content1: "No content available",
  dbh_studio_appendix: 'Appendix',
  dbh_studio_add_appendix: 'Add Appendix',
  dbh_studio_add__an_appendix: 'Add an appendix',
  dbh_studio_edit_appendix: 'Edit Appendix',
  dbh_studio_edit_insights: 'Edit Insights',
  dbh_studio_add__an_insights: 'Add an Insight',
  dbh_studio_edit_facts: 'Edit Facts',
  dbh_studio_add_insights: 'Add Insights',
  dbh_presentation_loading_failed: 'Data loading failed, ',
  dbh_presentation_click_reload: 'click to reload',
  dbh_download_this_report: 'Download this report',
  dbh_studio_aigallery_report_title: 'Discount Calendar',
  dbh_studio_aigallery_report_edit: 'AI Edit',
  dbh_studio_aigallery_report_download: 'Download',
  dbh_studio_aigallery_report_publish: 'Publish',
  dbh_studio_aigallery_report_toolbar_close: 'Hide toolbar',
  dbh_studio_aigallery_report_publish_to: 'Publish to',
  dbh_studio_aigallery_report_publish_dashboard: 'Dashboard',
  dbh_studio_aigallery_report_publish_intelligence: 'Intelligence',
  dbh_studio_aigallery_report_publish_opinion: 'Opinions',
  dbh_studio_aigallery_report_publish_incomplete: 'Required fields are incomplete',
  dbh_studio_aigallery_report_publish_success: 'Published successfully',
  dbh_studio_aigallery_report_publish_name_en: 'English Menu Title',
  dbh_studio_aigallery_report_publish_name_en_placeholder:
    'Enter the English display name of the report',
  dbh_studio_aigallery_report_publish_name_cn: 'Chinese Menu Title',
  dbh_studio_aigallery_report_publish_name_cn_placeholder:
    'Enter the Chinese display name of the report',
  dbh_studio_aigallery_report_publish_name_en_error:
    'Report name must be 1-50 characters and cannot include < > / ?',
  dbh_studio_aigallery_report_edit_query:
    'Please help me update the HTML with the following changes:',
  dbh_studio_filter_all: 'All',

  // CasualCompetitors Page Text
  // Genre Tab Options
  dbh_studio_casual_tab_general: 'General Casual',
  dbh_studio_casual_tab_iaa: 'IAA',
  dbh_studio_casual_tab_match3: 'Match-3',
  dbh_studio_casual_tab_merge2: 'Merge-2',
  dbh_studio_casual_tab_luck_battle: 'Lucky Battle',
  dbh_studio_casual_tab_hybrid_casual: 'Hybrid Casual',
  dbh_studio_casual_tab_simulation: 'Simulation',
  dbh_studio_casual_tab_rpg_idler: 'RPG Idler/Tower Defense',
  // IAA Sub-genre Tab Options
  dbh_studio_casual_tab_mahjong: 'Mahjong',
  dbh_studio_casual_tab_arrows: 'Arrows',
  dbh_studio_casual_tab_iaa_all: 'IAA All',
  // Merge-2 Sub-genre Tab Options
  dbh_studio_casual_tab_merge2_all: 'Merge-2 All',
  dbh_studio_casual_tab_merge2_narrative: 'Narrative Merge-2',
  // Key Games Tab Options
  dbh_studio_casual_key_games_tab_active: 'Active',
  dbh_studio_casual_key_games_tab_income: 'Revenue',
  dbh_studio_casual_key_games_tab_download: 'Downloads',
  // KPI Metrics - Monthly Granularity
  dbh_studio_casual_kpi_monthly_avg_dau: 'Monthly Avg. DAU',
  // KPI Metrics - Daily Granularity
  dbh_studio_casual_kpi_daily_dau: 'DAU',
  // Category Overview KPI Card Titles - Monthly
  dbh_studio_casual_category_kpi_monthly_dau: 'Market Total Monthly Avg. DAU',
  dbh_studio_casual_category_kpi_monthly_iap: 'Market Total IAP Revenue($)',
  dbh_studio_casual_category_kpi_monthly_download: 'Market Total Downloads',
  // Category Overview KPI Card Titles - Daily
  dbh_studio_casual_category_kpi_daily_dau: 'Market Total DAU',
  dbh_studio_casual_category_kpi_daily_iap: 'Market Total IAP Revenue($)',
  dbh_studio_casual_category_kpi_daily_download: 'Market Total Downloads',
  // Top Publishers KPI Card Titles - Monthly
  dbh_studio_casual_publisher_kpi_monthly_dau: 'Company Monthly Avg. DAU',
  dbh_studio_casual_publisher_kpi_monthly_iap: 'Company IAP Revenue($)',
  dbh_studio_casual_publisher_kpi_monthly_download: 'Company Downloads',
  // Top Publishers KPI Card Titles - Daily
  dbh_studio_casual_publisher_kpi_daily_dau: 'Company DAU',
  dbh_studio_casual_publisher_kpi_daily_iap: 'Company IAP Revenue($)',
  dbh_studio_casual_publisher_kpi_daily_download: 'Company Downloads',
  // Table Column Headers
  dbh_studio_casual_col_game_name: 'Game Name',
  dbh_studio_casual_col_monthly_avg_dau: 'Monthly Avg. DAU',
  dbh_studio_casual_kpi_monthly_iap_revenue: 'Monthly IAP Revenue($)',
  dbh_studio_casual_col_monthly_download: 'Monthly Downloads',
  dbh_studio_casual_col_daily_dau: 'DAU',
  dbh_studio_casual_kpi_daily_iap_revenue: 'Daily IAP Revenue($)',
  dbh_studio_casual_col_daily_download: 'Daily Downloads',
  dbh_studio_casual_genre_col_active_ratio: 'Active User Genre Share',
  dbh_studio_casual_company_col_active_ratio: 'Active User Company Share',
  // Common
  dbh_studio_casual_ratio: 'MoM',
  // Module Titles
  dbh_studio_casual_key_games_title: 'Key Games',
  dbh_studio_casual_dark_horse_title: 'Rising Games',
  dbh_studio_casual_top_publishers_title: 'Publisher Top Charts',
  // Module Switch
  dbh_studio_casual_top_games: 'Top Games',
  dbh_studio_casual_top_games_bubble:
    'Top games are curated from titles with monthly revenue > 10 million or manually maintained games worth attention, and the game list is updated quarterly.',
  // TODO: 更新Bubble文案
  dbh_studio_casual_rising_games_bubble: 'Rising Games Module',
  dbh_studio_casual_rising_games_bubble_daily_general_casual:
    'Includes all rising games within the subgenres on this page, selecting those with significant spikes in active user and revenue.',
  dbh_studio_casual_rising_games_bubble_daily_iaa_mahjong:
    'Select games within this genre with Monthly Downloads > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_iaa_arrows:
    'Select games within this genre with Monthly Downloads > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_iaa_all:
    'Select games within this genre with Monthly Downloads > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_match_3:
    'Select games within this genre with monthly revenue > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_merge_2:
    'Select games within this genre with monthly revenue > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_merge_2_narrative:
    'Select games within this genre with monthly revenue > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_lucky_battle:
    'Select games within this genre with monthly revenue > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_hybrid_casual:
    'Select games within this genre with monthly revenue > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_simulation:
    'Select games within this genre with monthly revenue > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_daily_rpg_tower_defense:
    'Select games within this genre with monthly revenue > 2 million and DoD growth > 5%.',
  dbh_studio_casual_rising_games_bubble_monthly_general_casual:
    'Includes all rising games within the subgenres on this page, selecting those with significant spikes in active user and revenue.',
  dbh_studio_casual_rising_games_bubble_monthly_iaa_mahjong:
    'Select games within this genre with Monthly Downloads > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_iaa_arrows:
    'Select games within this genre with Monthly Downloads > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_iaa_all:
    'Select games within this genre with Monthly Downloads > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_match_3:
    'Select games within this genre with monthly revenue > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_merge_2:
    'Select games within this genre with monthly revenue > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_merge_2_narrative:
    'Select games within this genre with monthly revenue > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_lucky_battle:
    'Select games within this genre with monthly revenue > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_hybrid_casual:
    'Select games within this genre with monthly revenue > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_simulation:
    'Select games within this genre with monthly revenue > 2 million and MoM growth > 20%.',
  dbh_studio_casual_rising_games_bubble_monthly_rpg_tower_defense:
    'Select games within this genre with monthly revenue > 2 million and MoM growth > 20%.',

  // ==================== Metric Tips ====================
  // Category Overview KPI Tips - Monthly
  dbh_studio_casual_kpi_monthly_avg_dau_tips:
    'Take the sum of metrics for all games within the genre.\n' +
    'Take the average value in selected time interval. \n' +
    'Monthly average DAU is calculated as the sum of daily active users over the month divided by the number of days in that month. As active users are not deduplicated, discrepancies may exist.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_kpi_cumulative_monthly_iap_tips:
    'Take the sum of metrics for all games within the genre.\n' +
    'Take the sum value in selected time interval. \n' +
    'Revenue has included 30% commission from in-app purchases, subscriptions and paid app downloads. IAA revenue is not included.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbi_studio_casual_kpi_cumulative_monthly_iap_tips:
    'Take the sum of metrics for all games within the genre.\n' +
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_kpi_cumulative_monthly_download_tips:
    'Take the sum of metrics for all games within the genre.\n' +
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  // Category Overview KPI Tips - Daily
  dbh_studio_casual_kpi_daily_dau_tips:
    'Take the sum of metrics for all games within the genre.\n' +
    'Take the average value in selected time interval.\n' +
    'As active users are not deduplicated, discrepancies may exist.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_kpi_cumulative_daily_iap_tips:
    'Take the sum of metrics for all games within the genre.\n' +
    'Take the sum value in selected time interval. \n' +
    'Revenue has included 30% commission from in-app purchases, subscriptions and paid app downloads. IAA revenue is not included.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbi_studio_casual_kpi_cumulative_daily_iap_tips:
    'Take the sum of metrics for all games within the genre.\n' +
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_kpi_cumulative_daily_download_tips:
    'Take the sum of metrics for all games within the genre.\n' +
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  // Key Games Table Tips - Monthly
  dbh_studio_casual_keygames_monthly_dau_tips:
    'Take the average value in selected time interval. \n' +
    'Monthly average DAU is calculated as the sum of daily active users over the month divided by the number of days in that month. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_keygames_monthly_iap_tips:
    'Take the sum value in selected time interval. \n' +
    'Revenue has included 30% commission from in-app purchases, subscriptions and paid app downloads. IAA revenue is not included.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbi_studio_casual_keygames_monthly_iap_tips:
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_keygames_monthly_download_tips:
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_keygames_monthly_active_ratio_tips:
    'Within the selected filters, this metric measures the proportion of a product’s Monthly Avg. DAU relative to the genre total Monthly Avg. DAU.',
  // Key Games Table Tips - Daily
  dbh_studio_casual_keygames_daily_dau_tips:
    'Take the average value in selected time interval.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_keygames_daily_iap_tips:
    'Take the sum value in selected time interval. \n' +
    'Revenue has included 30% commission from in-app purchases, subscriptions and paid app downloads. IAA revenue is not included.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbi_studio_casual_keygames_daily_iap_tips:
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_keygames_daily_download_tips:
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_keygames_daily_active_ratio_tips:
    'Within the selected filters, this metric measures the proportion of a product’s DAU relative to the genre total DAU.',
  // Top Publishers KPI Tips - Monthly
  dbh_studio_casual_publisher_kpi_monthly_dau_tips:
    'Take the sum of metrics for all games within the genre under this publisher.\n' +
    'Take the average value in selected time interval. \n' +
    'Monthly average DAU is calculated as the sum of daily active users over the month divided by the number of days in that month. As active users are not deduplicated, discrepancies may exist.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_kpi_monthly_iap_tips:
    'Take the sum of metrics for all games within the genre under this publisher.\n' +
    'Take the sum value in selected time interval. \n' +
    'Revenue has included 30% commission from in-app purchases, subscriptions and paid app downloads. IAA revenue is not included.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbi_studio_casual_publisher_kpi_monthly_iap_tips:
    'Take the sum of metrics for all games within the genre under this publisher.\n' +
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_kpi_monthly_download_tips:
    'Take the sum of metrics for all games within the genre under this publisher.\n' +
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  // Top Publishers KPI Tips - Daily
  dbh_studio_casual_publisher_kpi_daily_dau_tips:
    'Take the sum of metrics for all games within the genre under this publisher.\n' +
    'Take the average value in selected time interval.\n' +
    'As active users are not deduplicated, discrepancies may exist.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_kpi_daily_iap_tips:
    'Take the sum of metrics for all games within the genre under this publisher.\n' +
    'Take the sum value in selected time interval. \n' +
    'Revenue has included 30% commission from in-app purchases, subscriptions and paid app downloads. IAA revenue is not included.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbi_studio_casual_publisher_kpi_daily_iap_tips:
    'Take the sum of metrics for all games within the genre under this publisher.\n' +
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_kpi_daily_download_tips:
    'Take the sum of metrics for all games within the genre under this publisher.\n' +
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  // Top Publishers Table Tips - Monthly
  dbh_studio_casual_publisher_table_monthly_dau_tips:
    'Take the average value in selected time interval. \n' +
    'Monthly average DAU is calculated as the sum of daily active users over the month divided by the number of days in that month. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_table_monthly_iap_tips:
    'Take the sum value in selected time interval. \n' +
    'Revenue has included 30% commission from in-app purchases, subscriptions and paid app downloads. IAA revenue is not included.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbi_studio_casual_publisher_table_monthly_iap_tips:
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_table_monthly_download_tips:
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_table_monthly_active_ratio_tips:
    'Within the selected filters, this metric measures the proportion of a product’s Monthly Avg. DAU relative to the company-level Monthly Average DAU.',
  // Top Publishers Table Tips - Daily
  dbh_studio_casual_publisher_table_daily_dau_tips:
    'Take the average value in selected time interval.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_table_daily_iap_tips:
    'Take the sum value in selected time interval. \n' +
    'Revenue has included 30% commission from in-app purchases, subscriptions and paid app downloads. IAA revenue is not included.\n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbi_studio_casual_publisher_table_daily_iap_tips:
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_table_daily_download_tips:
    'Take the sum value in selected time interval. \n' +
    'Only App Store and Google Play platform data are provided, and other third-party platform data such as China Android data are not included.',
  dbh_studio_casual_publisher_table_daily_active_ratio_tips:
    'Within the selected filters, this metric measures the proportion of a product’s DAU relative to the company-leve DAU.',
  dbh_studio_fullscreen_enter: 'Fullscreen',
  dbh_studio_fullscreen_exit: 'Exit fullscreen',
};
